'use client';

import BlazeSlider from 'blaze-slider';
import 'blaze-slider/dist/blaze.css';
import { useEffect, useRef } from 'react';

export default function SocialProofSlider({ children, count, componentID }) {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = new BlazeSlider(sliderRef.current, {
      all: {
        slidesToShow: count,
        loop: false
      },
      '(max-width: 1024px)': {
        slidesToShow: count >= 4 ? 4 : count
      },
      '(max-width: 770px)': {
        slidesToShow: count >= 3 ? 3 : count
      },
      '(max-width: 600px)': {
        slidesToShow: count >= 2 ? 2 : count,
        slidesToScroll: 2,
        slideGap: '15px'
      }
    });

    return () => slider.destroy();
  }, [count]);

  return (
    <div
      ref={sliderRef}
      className={`blaze-slider social-proof-slider-${componentID} max-w-container relative mx-auto flex w-full flex-col justify-around`}
    >
      <div className="blaze-container">
        <div className="blaze-track-container px-6 sm:px-0">
          <ul className="blaze-track">{children}</ul>
        </div>
        <button className="blaze-prev hidden">
          <span className="sr-only">previous slide</span>
        </button>
        <button className="blaze-next hidden">
          <span className="sr-only">next slide</span>
        </button>
        <div className="blaze-pagination indicators-dark justify-content absolute -bottom-15 flex w-full sm:-bottom-[35px]"></div>
      </div>
    </div>
  );
}
